import React from "react";

import { useTheme } from '@mui/material/styles';

function UsersIcon({ color: customColor, isActive }) {
    const theme = useTheme();

    const color = isActive ? '#fff' : (customColor || theme.palette.icons.color);

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
            <circle cx={12} cy={6} r={4} stroke={color} strokeLinecap="round" strokeWidth={2} />
            <path stroke={color} strokeLinecap="round" strokeWidth={2} d="M5 20a7 7 0 0 1 7-7v0a7 7 0 0 1 7 7v.2a1.8 1.8 0 0 1-1.8 1.8H6.8A1.8 1.8 0 0 1 5 20.2V20Z" />
        </svg>
    );
}

export default UsersIcon;
